<template>
  <div class="w-full p-1 flex gap-2 bg-fill-2 rounded-xl text-sm">
    <div
      v-for="option in options"
      :key="option.value"
      class="h-[30px] leading-[30px] rounded-lg cursor-pointer text-text-2 px-3 flex-1 overflow-hidden text-center"
      :class="{ 'bg-white/15 text-white': modelValue === option.value }"
      @click="handleClick(option.value)"
    >
      {{ option.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  modelValue: number | string
  showLocal?: boolean
  options: { label: string, value: number | string }[]
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 0,
  showLocal: true,
  options: () => [],
})

const emit = defineEmits<{
  'update:modelValue': [value: number | string]
}>()

const handleClick = (value: number | string) => {
  emit('update:modelValue', value)
}
</script>

